export default __webpack_public_path__ + "static/media/bbb.78e3d0c4.jpg";